module.exports = __webpack_public_path__ + "img/6.8262f1c6.jpg";